import { isBlank } from '../verify';
export function decodeStr(value) {
  // 当是%的时候，报错Uncaught URIError: URI malformed
  // 可以替换，但是这里不需要
  try {
    return decodeURIComponent(value);
  } catch (e) {}
  return value;
}
export function getUrlParamByName(name) {
  var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)")); // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r !== null) return decodeStr(r[2]);
  return '';
}
/**
 * 解析所有Url中的params
 * @returns {{}}
 */
export function getUrlParams(value) {
  var search = value || window.location.search;
  if (search.length <= 0) return {};
  var info = search.slice(1);
  var result = {};
  var placeholder = {};
  var index = 0;
  var replaceInfo = info.replace(/=\((([^()]*|\([^()]*\))*)\)?/g, function (_$1, $2) {
    var str = "$$_".concat(index);
    placeholder[str] = decodeStr($2);
    index++;
    return "=".concat(str);
  });
  replaceInfo.split('&').forEach(function (item) {
    var itemArr = item.split('=');
    var encodeValue = itemArr[1] || '';
    var str = '';
    try {
      str = Object.prototype.hasOwnProperty.call(placeholder, encodeValue) ? placeholder[encodeValue] : encodeValue && encodeValue.indexOf('$$_') >= 0 ? '' : decodeStr(encodeValue);
    } catch (e) {
      str = '';
    }
    // 判断字符串true
    result[decodeStr(itemArr[0])] = str !== 'true' ? str : true;
  });
  return result;
}
/**
 * 合并剩余参数
 * @param url
 * @param params
 * @returns {*}
 */
export function jointParamsToStr(params, url) {
  if (url === void 0) {
    url = '';
  }
  var keys = Object.keys(params);
  if (!keys.length) {
    return url;
  }
  var joinStr = '?';
  keys.forEach(function (key) {
    var value = params[key];
    if (isBlank(value)) {
      return;
    }
    url += "".concat(joinStr).concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    joinStr = '&';
  });
  return url;
}